/* eslint-disable */
import { loginUser, getInfo, signUpUser } from '@/api/login'
import { getRequestCount } from "@/api/request.js";

const user = {
  state: {
    token: '',
    name: '',
    email: '',
    avatar: '',
    role: '',
    address: '',
    balance: '',
    requests_count: 0,
  },
  getters: {
    token: state => state.token,
    avatar: state => state.avatar,
    name: state => state.name,
    email: state => state.email,
    role: state => state.role,
    address: state => state.address,
    balance: state => state.balance,
    requests_count: state => state.requests_count,
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_EMAIL: (state, email) => {
      state.email = email
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLE: (state, role) => {
      state.role = role
    },
    SET_ADDRESS: (state, address) => {
      state.address = address
    },
    SET_BALANCE: (state, balance) => {
      state.balance = balance
    },
    SET_REQUESTS_COUNT: (state, requests_count) => {
      state.requests_count = requests_count
    }
  },

  actions: {
    LoginUser({ dispatch, commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        loginUser(username, userInfo.password).then(response => {
          const data = response
          commit('SET_TOKEN', data.jwt)
          commit('SET_NAME', data.user.username)
          commit('SET_EMAIL', data.user.email)
          commit('SET_BALANCE', data.user.balance)
          commit('SET_AVATAR', `https://ui-avatars.com/api/?name=${data.user.username}`)
          if (data.user.wallet && data.user.wallet.address) {
            commit('SET_ADDRESS', data.user.wallet.address)
          }
          commit('SET_ROLE', data.user.role.type)
          commit('SET_EMAIL', data.user.email)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    SignUpUser({ dispatch, commit }, userInfo) {
      return new Promise((resolve, reject) => {
        signUpUser(userInfo.email, userInfo.password).then(response => {
          const data = response
          if (data.user.confirmed === true) {
            commit('SET_TOKEN', data.jwt)
          }
          commit('SET_NAME', data.user.username)
          if (data.user.wallet && data.user.wallet.address) {
            commit('SET_ADDRESS', data.user.wallet.address)
          }
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token).then(response => {
          const data = response
          commit('SET_BALANCE', data.balance)

          if (data.role && data.role.name) {
            commit('SET_ROLE', data.role.name)
          } else {
            reject('getInfo: role not found !')
          }
          commit('SET_NAME', data.username)
          commit('SET_EMAIL', data.email)
          commit('SET_AVATAR', `https://ui-avatars.com/api/?name=${data.username}`)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    LogOut({ dispatch, commit, state }) {
      return new Promise((resolve, reject) => {
        commit('SET_TOKEN', '')
        commit('SET_ROLE', '')
        commit('SET_NAME', '')
        commit('SET_EMAIL', '')
        commit('SET_AVATAR', '')
        commit('SET_ADDRESS', '')
        commit('SET_BALANCE', '')
        resolve()
      })
    },

    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        resolve()
      })
    },

    UpdateRequestsCount({ commit }) {
      getRequestCount().then(response => {
        return new Promise(resolve => {
          commit('SET_REQUESTS_COUNT', response)
          resolve()
        })
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js